import React from 'react';
import {observer} from 'mobx-react';

function WhiteSpaceForm({options}) {
  let typeSelect = {};
  let exactlyInput = {};
  let betweenFromInput = {};
  let betweenToInput = {};
  let relativitySelect = {};
  let relativitySubSelect = null;
  let relativityInput = {};

  const renderBasedOnSelection = (selection) => {
    switch(selection) {
      case 'exactly':
        return (
          <input
            type="number"
            placeholder="exactly"
            value={options.whiteSpace.value}
            onChange={handleExactlyChange}
            ref={el => exactlyInput = el}
          />
        );
      case 'between':
        return (
          <div>
            <input
              type="number"
              placeholder="from"
              value={options.whiteSpace.from}
              onChange={handleBetweenChange}
              ref={el => betweenFromInput = el}
            />
            <input
              type="number"
              placeholder="to"
              value={options.whiteSpace.to}
              onChange={handleBetweenChange}
              ref={el => betweenToInput = el}
            />
          </div>
        );
      case 'relativeTo':
        return (
          <div>
            <select
              value={options.whiteSpace.relativeTo}
              onChange={handleRelativeToChange}
              ref={el => relativitySelect = el}
            >
              <option value="---">---</option>
              {Object.keys(options.brochureSettings).filter(key => key !== options.title).map(key => {
                return <option key={key} value={key}>{key}</option>
              })}
            </select>
            <select
              value={options.whiteSpace.relativeToType}
              onChange={handleRelativeToChange}
              ref={el => relativitySubSelect = el}
            >
              <option value="---">---</option>
              <option value="smallerBy">Smaller By</option>
              <option value="largerBy">Larger By</option>
              <option value="equal">Equal</option>
            </select>
            <input
              type="number"
              placeholder={options.whiteSpace.relativeToType}
              value={options.whiteSpace.value}
              onChange={handleRelativeToChange}
              ref={el => relativityInput = el}
            />
          </div>
        );
      default:
        return <p>FAIL</p>
    }
  };

  const handleExactlyChange = () => {
    options.setValue({
      type: typeSelect.value,
      value: exactlyInput.value
    });
  };

  const handleBetweenChange = () => {
    options.setValue({
      type: typeSelect.value,
      from: betweenFromInput.value,
      to: betweenToInput.value
    });
  };

  const handleRelativeToChange = () => {
    options.setValue({
      type: typeSelect.value,
      relativeTo: relativitySelect.value,
      relativeToType: relativitySubSelect.value,
      value: relativityInput.value
    });
  };

  const handleTypeChange = (e) => {
    options.setValue({
      type: 'new',
      value: e.target.value
    });
  };

  return (
    <div>
      <select
        value={options.whiteSpace.type}
        onChange={handleTypeChange}
        ref={el => typeSelect = el}
      >
        <option value="exactly">Exactly</option>
        <option value="between">Between</option>
        <option value="relativeTo">relativeTo</option>
      </select>
      { renderBasedOnSelection(options.whiteSpace.type) }
    </div>
  );
}

export default observer(WhiteSpaceForm);



// WEBPACK FOOTER //
// ./src/views/SheetCalculator/Components/WhiteSpaceForm.js